import {getVariationJsonData} from './PanoramaVariationObtainingUtils.jsx';
import {usePromises} from './PanoramaUtilsReact.jsx';


/**
 * Returns the variation JSON data.
 *
 * If homeVersion is 'latest' (or null, or undefined), it will first fetch the latest version from the home.
 *
 * @param {Object} props
 * @param {string} props.homeId
 * @param {string|null} [props.homeVersion]
 * @param {string|null} [props.host]
 * @returns [{version:string, url:string, data:Object}|null, boolean, string|null]
 */
export const useVariationJsonData = (props) =>
{
	const {homeId, homeVersion, host} = props;
	return usePromises(() => getVariationJsonData({homeId, homeVersion, host}), [homeId, homeVersion, host]);
};
